<div class="card card-w-title">
  <h1>Registri</h1>
  <app-register-selector (selected)="registerSelected($event)" [elencoRegistri]="elencoRegistri">
  </app-register-selector>
  <app-time-selector (dateRangeChanged)="dateRangeChanged($event)">
  </app-time-selector>
  <div class="flex justify-content-end my-4">
    <p-button label="Visualizza Registro" (onClick)="generaRegistro()" [disabled]="formIsNotValid"></p-button>
  </div>
  @if (selectedRegister && colsToPrint && registroToPrint) {
  <div id="pdfTableRiproduzioni" class="table-riproduzioni">
    <h1>{{title}}</h1>
    <p-button label="Stampa" (onClick)="GeneraPDFRegistro()" [disabled]="formIsNotValid"></p-button>
    <div class="mt-2">
      <app-register-result-table [data]="registroToPrint" [columns]="colsToPrint" [scrollable]="true" scrollHeight="37vh"
        [registerType]="selectedRegister.tipo.registroTipoId">
      </app-register-result-table>
    </div>
  </div>
  }
</div>